/* eslint-disable react-hooks/exhaustive-deps */
import { BackgroundCard, MessageBox } from '@davies-group/white-label-ui/ui';
import * as React from 'react';
import { Box, Typography } from '@mui/material';

import { useDocumentUpload } from '../../context/DocumentUploadContext';
import { IPage } from '../IPage';

export const CompletedPage = () => {
    const { dispatch } = useDocumentUpload();

    React.useEffect(() => {
        dispatch({ type: 'updateIsLoading', payload: false });
    }, []);

    return (
        <BackgroundCard>
            <Box p={4} justifyContent="center">
                <Box pb={2} width={1} display="flex" alignItems="flex-start">
                    <Typography color="secondary" align="left" variant="h4">
                        <strong>Documents submitted</strong>
                    </Typography>
                </Box>

                <Box pb={2} width={1}>
                    <MessageBox>
                        <Typography sx={{ fontWeight: 'bold' }}>Thank you for sending us your requested documents. We will be in touch shortly.</Typography>
                    </MessageBox>
                </Box>
            </Box>
        </BackgroundCard>
    );
};

const completedPage: IPage = {
    title: 'CompletedPage',
    route: {
        path: '/:requestId/completed',
        element: <CompletedPage />,
    },
};

export default completedPage;
